// https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=34636717 账户状态/权限 @黄翀
export const HOST = [
    'https://tesseract-dev.ihuhoo.com',
    'https://tesseract.tradeup.com',
    'https://tesseract-dev.ihuhoo.com'
];
export const API = {
    // @张斌 获取账户权限: https://apidocs.tigerfintech.com/repository/29/api/master/APP-Web.json#/operations/get--api-v3-account-permission
    getAccountPermission: '/api/v3/account/permission'
};

// 使用cg返回的数据，如果有牌照或者region等多种域名区分，需要在这里逐一展开
export function bindCG() {
    const cfg = CG_API.tesseract?.COMMON;

    cfg && HOST.fill(cfg);
}
